/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_CoffeeInputs */

const he_home_category_coffee = /** @type {(inputs: Home_Category_CoffeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מכונות קפה`)
};

const en_home_category_coffee = /** @type {(inputs: Home_Category_CoffeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffee Machines`)
};

/**
* | output |
* | --- |
* | "Coffee Machines" |
*
* @param {Home_Category_CoffeeInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_coffee = /** @type {((inputs?: Home_Category_CoffeeInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_CoffeeInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_coffee(inputs)
	return en_home_category_coffee(inputs)
});